export default function noop() {
}
